import React, { useRef, useState, useEffect } from "react";
import "./style.css";
import { Menu,MenuButton, MenuList, MenuItem, IconButton, Button } from "@chakra-ui/react";

import { ChevronDownIcon, CloseIcon } from "../../../Assets/images/svgs/";
import { TimePicker } from  "../../Atoms";

const DateTimePickerModal = ({ isOpen = false, rideStart, rideEnd, onSubmit, onClose, onReset, errMsg = "" }) => {
  const [ selectedFromTime, setSelectedFromTime ] = useState(0);
  const [ selectedToTime, setSelectedToTime ] = useState(0);

  const [ enableApply, setEnableApply ] = useState(false);

  const generateDatePickerOptions = () => {
    if (rideStart && rideEnd) {
      let dates = [];
      if (new Date(rideStart).getDate() === new Date(rideEnd).getDate()) {
        dates.push({ name: new Date(rideStart).toLocaleDateString("en-IN", { day: "2-digit",  month: "long" }), ts: rideStart });
      } else {
        dates.push({ name: new Date(rideStart).toLocaleDateString("en-IN", { day: "2-digit",  month: "long" }), ts: rideStart });
        dates.push({ name: new Date(rideEnd).toLocaleDateString("en-IN", { day: "2-digit",  month: "long" }), ts: rideEnd });
      }

      return dates;
    }
  }

  const dateOptions = useRef(generateDatePickerOptions());
  const [ selectedFromDate, setSelectedFromDate ] = useState(dateOptions.current.length === 1 ? dateOptions.current[0] : 0);
  const [ selectedToDate, setSelectedToDate ] = useState(dateOptions.current.length === 1 ? dateOptions.current[0] : 0);

  const resetSelectedData = () => {
    if (dateOptions.length > 1) {
      setSelectedFromDate(0);
      setSelectedToDate(0);
    }
    setSelectedFromTime(0);
    setSelectedToTime(0);
    onReset();
  }

  const handleRideTimeSelection = (event) => {
    event.stopPropagation();

    if (selectedFromTime.meridiem === "AM") {
      selectedFromTime.hrs = selectedFromTime.hrs - 12;
    }

    if (selectedToTime.meridiem === "AM") {
      selectedToTime.hrs = selectedToTime.hrs - 12;
    }

    if (!selectedFromDate || !selectedToDate || !selectedFromTime || !selectedToTime) {
      return;
    }

    let startTs = new Date(selectedFromDate.ts).setHours(selectedFromTime.hrs, selectedFromTime.mins, 0, 0);
    let endTs = new Date(selectedToDate.ts).setHours(selectedToTime.hrs, selectedToTime.mins, 0, 0);

    if (errMsg && enableApply) setEnableApply(false);

    onSubmit(startTs, endTs);
  }

  useEffect(() => {
    if (errMsg) setEnableApply(false);
  }, [ errMsg ])

  return (
    <div className={`date-time-picker-modal ${isOpen ? "" : "hide-modal"}`}>
      <IconButton
        className="close-modal-button"
        icon={<CloseIcon />}
        onClick={(event) => onClose(event)}
      />
      <p className="modal-heading">Select ride time</p>
      <div className="date-time-picker-form">

        <div className="from-picker">
          <label className="date-picker-label">
            <p className="label">From Date</p>
            <Menu>
              <MenuButton className={`date-picker-menu-button ${selectedFromDate ? "selected" : ""}`}>
                {`${selectedFromDate ? `${selectedFromDate.name}` : "Select Date"}`}
                <ChevronDownIcon />
              </MenuButton>
              {dateOptions.current.length ? <MenuList>
                {
                  dateOptions.current.map((option, idx) => (
                    <MenuItem key={idx} onClick={() => setSelectedFromDate(option)}>{ option.name }</MenuItem>
                  ))
                }
              </MenuList> : null}
            </Menu>
          </label>
          <label>
            <p className="label">From</p>
            <TimePicker rideStart={rideStart} rideEnd={rideEnd} onSelect={(slot, meridiem) => {setEnableApply(true); setSelectedFromTime({ ...slot, meridiem })}} value={selectedFromTime} />
          </label>
        </div>

        <div className="seperator"></div>

        <div className="to-picker">
          <label className="date-picker-label">
            <p className="label">To Date</p>
            <Menu>
              <MenuButton className={`date-picker-menu-button ${selectedToDate ? "selected" : ""}`}>
                {`${selectedToDate ? `${selectedToDate.name}` : "Select Date"}`}
                <ChevronDownIcon />
              </MenuButton>
              <MenuList>
                {
                  dateOptions.current.map((option, idx) => (
                    <MenuItem key={idx} onClick={() => setSelectedToDate(option)}>{ option.name }</MenuItem>
                  ))
                }
              </MenuList>
            </Menu>
          </label>
          <label>
            <p className="label">To</p>
            <TimePicker rideStart={rideStart} rideEnd={rideEnd} onSelect={(slot, meridiem) => {setEnableApply(true); setSelectedToTime({ ...slot, meridiem })}} value={selectedToTime} />
          </label>
        </div>

      </div>

      {!enableApply && errMsg ? <p className="time-picker-error-msg">{errMsg}</p> : null}

      <div className="date-time-picker-modal-footer">
        <Button onClick={resetSelectedData} className={`reset-button ${(!selectedFromDate && !selectedToDate && !selectedFromTime && !selectedToTime) ? "" : "active"}`} disabled={!selectedFromDate && !selectedToDate && !selectedFromTime && !selectedToTime}>Reset</Button>
        <Button onClick={handleRideTimeSelection} className={`apply-button ${(!selectedFromDate || !selectedToDate || !selectedFromTime || !selectedToTime || !enableApply) ? "" : "active"}`} disabled={!selectedFromDate || !selectedToDate || !selectedFromTime || !selectedToTime}>Apply</Button>
      </div>
    </div>
  )
}

export default DateTimePickerModal
